<template>
  <div class="leaflet-page">
    <img src="//download-cos.yofish.com/youyu-gongjushiyebu/20220330173159297-999.png"
      width="100%" alt="">
    <!-- <div class="submit-btn" @click="applyAction">
      <img src="~@/assets/images/leaflet/appy-btn.png" width="100%" alt="">
    </div> -->
    <y-dialog :visible="visible">
      <div class="head">
        <img src="~@/assets/images/leaflet/frame.png" alt="" width="100%">
      </div>
      <div class="apply-content">
        <div class="input">
          <input type="text" placeholder="请输入手机号码" v-model="phoneNumber" />
        </div>
      </div>
      <div class="apply-btn" slot="footer" @click="submitAction">
        <img src="~@/assets/images/leaflet/submit-btn.png" width="100%" alt="">
      </div>
    </y-dialog>
  </div>
</template>
<script>
import { huaxiaDataSubmitApi } from '@/api/base1';
import { getAppStatus, callAppHandler } from '@/utils/app';
import YDialog from '@/components/dialog';

export default {
  name: 'HuaxiaBank',
  components: { YDialog },
  data() {
    return {
      visible: true,
      phoneNumber: '',
      userId: getAppStatus().cuserId,
    };
  },
  watch: {
    visible(val) {
      if (!val) this.phoneNumber = '';
    },
  },
  mounted() {
    document.title = '华夏银行宣传页';
    this.userId = this.userId || sessionStorage.getItem('userId');
    if (!this.userId) {
      callAppHandler('jzUserId', null, (res) => {
        sessionStorage.setItem('userId', res);
        this.userId = res;
      });
    }
  },
  computed: {
    phone() {
      return getAppStatus().phone;
    },
    userIds() {
      // "6bbf384d-dacd-472e-8c9f-d013c59d20b9"
      return getAppStatus().cuserId;
      // return '6bbf384d-dacd-472e-8c9f-d013c59d20b9';
    },
  },
  methods: {
    async getUploadClickAction() {
      let res;
      const {
        phoneNumber,
      } = this;
      const { query } = this.$route;
      const params = {
        mobile: phoneNumber,
        source: 'yofish',
        linkIndex: query.linkIndex,
      };
      try {
        res = await huaxiaDataSubmitApi(params);
      } catch (e) {
        console.log(e);
        this.$toast({ content: '网络异常!', duration: 2000 });
        // setTimeout(() => {
        //   this.visible = false;
        // }, 300);
      }
      if (res?.code === '1') {
        let linkUrl = res.data;
        window.open(linkUrl, '_self');
      } else {
        this.$toast(res?.desc || '网络异常');
      }
    },
    applyAction() {
      this.visible = true;
    },
    submitAction() {
      const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(15[0-3]{1})|(15[4-9]{1})|(18[0-9]{1})|(199))+\d{8})$/;
      if (!this.phoneNumber) {
        this.$toast({ content: '请填写手机号!', duration: 2000 });
      } else if (this.phoneNumber.length < 11 || !myreg.test(this.phoneNumber)) {
        this.$toast({ content: '手机号填写有误,请重新输入!', duration: 2000 });
      } else {
        this.getUploadClickAction();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.leaflet-page {
  width: 100%;
  // overflow: hidden;
  position: relative;
  .head {
    width: 236px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -90px;
    z-index: 30;
  }
  .submit-btn {
    width: 690px;
    height: 110px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 59px;
  }
}
.apply-content {
  padding: 165px 49px 0 49px;
  .input {
    position: relative;
    width: 100%;
    height: 60px;
    // border-bottom: 2px solid #E5E4E4;
    input {
      border-bottom: 2px solid #E5E4E4;
    }
  }
  input {
    width: 100%;
    height: 55px;
    border: none;
    font-size: 28px;
    &::-webkit-input-placeholder {
      font-size: 28px;
      color: #CDCDCD;
    }
  }
}
.apply-btn {
  width: 538px;
  height: 79px;
  border: 2px solid #FFFFFF;
  border-radius: 40px;
  line-height: 79px;
  text-align: center;
  font-size: 47px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  font-style: italic;
  color: #FFFFFF;
  text-shadow: 0px 4px 5px rgba(13, 127, 134, 0.56);
  margin: 45px auto 0;
}
</style>
